import {Box, darken} from "@mui/material";

const HighlightPanel = ({color, children}) => {
    return <Box sx={{
        padding: 2,
        marginBottom: 2,
        backgroundColor: color,
        borderRadius: '18px',
        border: '1px solid',
        borderColor: darken(color, 0.5)
    }}>
        {children}
    </Box>
}

export default HighlightPanel